import { IProgramType } from '../models/programType'

type TGetAvailableProgramTypes = {
  isNewOfferingsMode: boolean
  isHybridPartner: boolean
}

export const getAvailableProgramTypes = (
  programTypes: IProgramType[],
  { isNewOfferingsMode, isHybridPartner }: TGetAvailableProgramTypes
) => {
  if (isHybridPartner) {
    return programTypes.filter((it) => !it.isDeprecated)
  }

  return programTypes.filter((it) => (isNewOfferingsMode ? !it.isDeprecated : it.isDeprecated))
}
